var _rect, _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrimaryDiagnosis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F9F5E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.0014C16.4997 11.3162 16.0675 12.5945 15.2699 13.6397C14.4723 14.685 13.3535 15.4393 12.0854 15.7868C10.8173 16.1342 9.47022 16.0554 8.25124 15.5626C7.03227 15.0699 6.00891 14.1903 5.33852 13.0593C4.66813 11.9282 4.38782 10.6082 4.54071 9.30233C4.69359 7.99644 5.2712 6.77692 6.18472 5.83128C7.09823 4.88565 8.29707 4.26626 9.59691 4.06836C10.8967 3.87046 12.2256 4.10501 13.3791 4.73593",
    stroke: "#F18D09",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 12.5725C11.9201 12.5725 13.0713 11.4213 13.0713 10.0011C13.0713 8.58095 11.9201 7.42969 10.4999 7.42969C9.07973 7.42969 7.92847 8.58095 7.92847 10.0011C7.92847 11.4213 9.07973 12.5725 10.4999 12.5725Z",
    stroke: "#F18D09",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 3,
    fill: "#F18D09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7858 7.42955C15.7326 7.42955 16.5001 6.66203 16.5001 5.71526C16.5001 4.76849 15.7326 4.00098 14.7858 4.00098C13.839 4.00098 13.0715 4.76849 13.0715 5.71526C13.0715 6.66203 13.839 7.42955 14.7858 7.42955Z",
    stroke: "#F18D09",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryDiagnosis);
export default __webpack_public_path__ + "static/media/PrimaryDiagnosis.9f124d4e6d13a905573c8599952d75f8.svg";
export { ForwardRef as ReactComponent };